<div class="row space-between w100 align-center">
  <h4 i18n class="strong">{{ label }}</h4>
  <input
    type="file"
    name="file"
    id="file"
    #file
    hidden
    accept=".pdf, .txt, .rtf, .md, .csv, .json"
    multiple
    (change)="onFileSelected($event)"
  />
  <rr-btn
    size="small"
    type="secondary"
    iconStart="add"
    (btnclick)="file.click()"
    >Add File</rr-btn
  >
</div>
<div
  class="dorpdownarea w100"
  (click)="file.click()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <rr-icon name="add"></rr-icon>
  <span i18n class="tiny">
    Drag and drop files (*.pdf, *.txt, *.rtf, *.md, *.csv, *.json) here to upload additional resources for your
    project.
  </span>
</div>
<div class="progressarea" *ngFor="let f of files">
  <span class="filecounter gap-16 row align-center">
    <rr-icon name="file" class="file"></rr-icon>
    <span class="name col" [title]="f?.name">
      <span>{{ f?.name }}</span>
      <span class="tiny">{{ f.size | calcFileSizeInKb }}</span>
    </span>
    <div class="errortext" *ngIf="f.error == true">{{ f.errorText }}</div>
    <div class="progress" *ngIf="!f.error">
      <rr-progress *ngIf="f.percentage" [progress]="f.percentage"></rr-progress>
    </div>
    <rr-icon
      [name]="!f.error ? 'close' : 'error'"
      [class]="!f.error ? 'close' : 'error'"
      (click)="deleteFile(f)"
    ></rr-icon>
  </span>
</div>
